import { Component, OnInit, Input, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { EmployeeDTO, OrderModel } from 'src/app/store/order/model';
import { UrgencyFacade } from 'src/app/store/urgency/facade';
import { UrgencyModel } from 'src/app/store/urgency/model';
import { AbstractOrderApiService } from 'src/app/core/services/abstract/abstract-order-api-service';
import { AbstractOrderUIService } from 'src/app/core/services/abstract/abstract-order-ui-service';
import { OrderFacade } from 'src/app/store/order/facade';
import { UserFacade } from 'src/app/store/user/facade';
import { TranslateService } from '@ngx-translate/core';
import { AppConstants } from 'src/app/core/constants/app-constants';
import { InteractorResponse } from 'src/app/core/models/interactor-response';
import { OrderStatusConstants } from '../../../../core/constants/order-status-constants';

@Component({
  selector: 'app-order-tab-basic',
  templateUrl: './order-tab-basic.component.html',
  styleUrls: ['./order-tab-basic.component.scss'],
  standalone: false,
})
export class OrderTabBasicComponent implements OnInit {
  translate = inject(TranslateService);
  private orderApiService = inject(AbstractOrderApiService);
  private urgencyFacade = inject(UrgencyFacade);
  orderUIService = inject(AbstractOrderUIService);
  private orderFacade = inject(OrderFacade);
  private userFacade = inject(UserFacade);

  @Input() order: OrderModel;

  urgencies$: Observable<UrgencyModel[]>;
  coordinators$: Observable<InteractorResponse<EmployeeDTO[]>>;

  userId: number;

  showCoordinator: boolean = false;
  public _orderStatuses = OrderStatusConstants.OrderStatuses;

  ngOnInit(): void {
    this.urgencies$ = this.urgencyFacade.allUrgencies$;

    this.userFacade.selected().subscribe(res => {
      if (res) {
        this.coordinators$ = this.orderApiService.getCoordinatorEmployees(
          this.order.employeeFor.id,
          this.order.service.id,
          this.order.task.id
        );
      }
    });

    this.orderFacade.selectedEmployeeForId().subscribe(id => {
      if (id) {
        this.coordinators$ = this.orderApiService.getCoordinatorEmployees(id, this.order.service.id, this.order.task.id);
        if (this.showCoordinator && !this.order.coordinator?.id && this.coordinators$) {
          this.coordinators$.subscribe(res => {
            if (res.result?.length) {
              this.order.coordinator = res.result[0];
            }
          });
        }
      }
    });

    // If new Orders
    if (!this.order.id && this.coordinators$ && this.showCoordinator) {
      this.coordinators$.subscribe(res => {
        if (res.result?.length) {
          this.order.coordinator = res.result[0];
        }
      });
    }

    this.orderFacade.template().subscribe(x => {
      this.showCoordinator = x && x.requestNeedAgree;

      if (this.showCoordinator == true && this.order && !this.order.coordinator) {
        this.order.coordinator = new EmployeeDTO(null, null);
      }
    });

    this.userFacade.selected().subscribe(x => {
      if (x) {
        this.userId = x.id;
      }
    });
  }

  getUrgencyFieldName() {
    return this.translate.currentLang == AppConstants.LANGUAGE_UK ? 'nameUa' : 'name';
  }
}
